import React from "react"
import styles from "./WhyEarlyPlanningImportant.module.css"
import Image from "../Common/Image/Image"
import TickIcon from "../../assets/EarlyPlanning/TickIcon.svg"
import PointersData from './WhyEarlyPlanningImportant.json'

interface PointerItem {
  title: string
  description: string
}

const pointerData: PointerItem[] = PointersData;

const WhyEarlyPlanningImportant = () => {
  return (
    <section className={styles.Container}>
      
      {/* Title */}
      <h2 className={styles.Title}>
        Why is early planning for your child’s education important?
      </h2>

      {/* Description */}
      <p className={styles.Description}>
      Here’s why early financial planning for your child’s education is important:
      </p>

      {/* Grid */}
      <div className={styles.Grid}>
        {pointerData.map((item, index) => (
          <div key={index} className={styles.Item}>
            
            {/* Top Row (Icon + Title) */}
            <div className={styles.ItemHeader}>
              <Image src={TickIcon} alt={item.title} className={styles.Icon} />
              <h3 className={styles.ItemTitle}>{item.title}</h3>
            </div>

            {/* Description */}
            <p className={styles.ItemDescription}>
              {item.description}
            </p>

          </div>
        ))}
      </div>
      <p className={styles.BottomText}>IL/COMP/DOC/Mar/2026/183/2206</p>
    </section>
  )
}

export default WhyEarlyPlanningImportant